import { Badge } from '@vrplatform/components';
import type { ThemeColor } from '@vrplatform/theme';
import { Group } from '@mantine/core';

import type { DrawerInfoCardLockBadge } from './DrawerInfoCardLockBadges.utils';

type Props = {
  badges: DrawerInfoCardLockBadge[];
  color?: ThemeColor;
};

export const DrawerInfoCardLockBadges = ({
  badges,
  color = 'portal.gray',
}: Props) => {
  if (!badges.length) return null;

  return (
    <Group gap={4} wrap="wrap">
      {badges.map((badge) => (
        <Badge
          key={badge.label}
          color={badge.color ?? color}
          tooltip={badge.tooltip}
        >
          {badge.label}
        </Badge>
      ))}
    </Group>
  );
};
